module.exports = __webpack_public_path__ + "img/process_04.f1a441fa.png";